import get from 'lodash/get'
import PropTypes from 'prop-types'
import React from 'react'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'

import {fastlyImpolicyDCThumbnail} from '../../utils'

import * as pdp from '../../store/productDetailPage'
import * as track from '../../track/track'

import ProductSetItem from '../Pieces/ProductSetItem'
import ProductSetSliderWrapper from '../Pieces/ProductSetSliderWrapper'

const formatItems = (isAddItemsFlow, items) =>
  items.map((item) => {
    const urlString = `${isAddItemsFlow ? '/add-items' : ''}/collection/${
      item.childSet.defaultDisplayCategorySlug
    }/${item.childSet.urlSlug}`
    return (
      <ProductSetItem
        key={item.id}
        handleClick={() => track.pdpClicked(item.childSet.name, urlString)}
        itemName={item.childSet.name}
        productImage={`${get(item, 'childSet.setImages[0].url')}${fastlyImpolicyDCThumbnail}`}
        url={urlString}
      />
    )
  })

const ProductOutfitItems = ({isAddItemsFlow = false, items}) => (
  <div className="product-outfit-items">
    {items && (
      <ProductSetSliderWrapper
        formattedItems={formatItems(isAddItemsFlow, items)}
        title="This outfit includes these products"
      />
    )}
  </div>
)

ProductOutfitItems.propTypes = {
  isAddItemsFlow: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      childSet: PropTypes.shape({}).isRequired,
    }),
  ),
}

const mapStateToProps = createStructuredSelector({
  items: pdp.setChildren,
})

export default connect(mapStateToProps)(ProductOutfitItems)
